/** Settings sections — the order here is the tab order. Sections fill in across stages. */
export const SETTINGS_SECTIONS = [
  "account",
  "billing",
  "general",
  "personalization",
  "memory",
  "connectors",
] as const;

export type SettingsSection = (typeof SETTINGS_SECTIONS)[number];

/** Coerce an untrusted `?section` search value to a known section (default = first tab). */
export function parseSection(value: unknown): SettingsSection {
  return SETTINGS_SECTIONS.includes(value as SettingsSection)
    ? (value as SettingsSection)
    : "account";
}
